import Select from 'react-select';
import { useState, useRef, useEffect } from 'react';

export default function SpecificSelectControl({ value={}, metaKey, updateEditedMeta }) {
    const selectedRules = value.rule || [];
    const selectedSpecifics = value.specific || [];
    const selectedSpecificText = value.specificText || [];

    const [options, setOptions] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState(selectedSpecificText || []);
    const abortControllerRef = useRef(null);

    useEffect(() => {
        if (Array.isArray(selectedSpecificText) && selectedSpecificText.length > 0) {
            setSelectedOptions(selectedSpecificText);
        } else {
            const flat = options.flatMap(group => group.options);
            const mapped = flat.filter(opt => selectedSpecifics.includes(opt.value));
            setSelectedOptions(mapped);
        }
    }, [selectedSpecifics, selectedSpecificText, options]);

    if (!selectedRules.includes('specifics')) return null;

    const debounceFetch = (() => {
        let timeout;
        return (inputValue) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                fetchOptions(inputValue);
            }, 300);
        };
    })();

    const fetchOptions = (input) => {
        if (abortControllerRef.current) abortControllerRef.current.abort();

        if (!input || input.length < 2) {
            setOptions([]);
            return;
        }

        abortControllerRef.current = new AbortController();

        const body = new URLSearchParams({
            action: 'responsive_sb_get_posts_by_query',
            q: input,
            nonce: responsive_addons_site_builder?.ajax_nonce || '',
        });

        fetch(responsive_addons_site_builder.ajax_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString(),
            signal: abortControllerRef.current.signal,
        })
            .then((res) => res.json())
            .then((data) => {
                const grouped = Object.entries(data).map(([groupLabel, group]) => ({
                    label: group.text,
                    options: Object.entries(group.children).map(([k, v]) => ({
                        value: v.id,
                        label: v.text,
                    })),
                }));
                setOptions(grouped);
            })
            .catch((err) => {
                if (err.name !== 'AbortError') {
                    console.error('Error fetching data:', err);
                }
            });
    };

    const handleChange = (selected) => {
        const values = selected.map(opt => opt.value);
        setSelectedOptions(selected);
        updateEditedMeta(metaKey, {
            ...value,
            specific: values,
            specificText: selected,
        });
    };

    return (
        <div>
            <Select
                isMulti
                isSearchable
                value={selectedOptions}
                onChange={handleChange}
                onInputChange={debounceFetch}
                options={options}
                menuPortalTarget={document.body}
                className="responsive-sb-meta-select"
                classNamePrefix="responsive"
                styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                    option: (base) => ({ ...base, cursor: 'pointer' })
                }}
            />
        </div>
    );
}
